export default (state = {}, action) => {
  switch (action.type) {
    case "LOGIN":
      return { ...action.user };
    case "UPDATE_PROFILE":
      return { ...state, ...action.profile };
    case "SET_ALERT_DATA":
      return {
        ...state,
        alert_channels: action.data
      };
    case "SET_LABELS_DATA":
      return {
        ...state,
        labels: action.data
      };
    case "LOGOUT":
      return {};
    default:
      return state;
  }
};
